import type { ReactNode } from "react";
import { ContentSkeleton } from "@/components/layout/AppShellSkeleton";
import BrandRecapModal from "@/components/discover/BrandAnalysisModal";
import DiscoverSkeleton from "@/components/discover/DiscoverSkeleton";
import { useCommunityAccess } from "@/hooks/use-community-access";

/**
 * Shows community pages to approved brands; everyone else gets the review notice, centered over a blurred
 * stand-in for Discover, with the sidebar still usable. The stand-in carries no data and loads nothing.
 */
const CommunityAccessGate = ({ children, loadingFallback }: { children: ReactNode; loadingFallback?: ReactNode }) => {
  const { allowed, loading } = useCommunityAccess();
  if (loading) {
    return <>{loadingFallback ?? <ContentSkeleton />}</>;
  }
  if (!allowed) {
    return (
      <div className="relative min-h-screen overflow-hidden">
        <div aria-hidden className="pointer-events-none absolute inset-0 select-none overflow-hidden opacity-70 blur-[7px]">
          <DiscoverSkeleton />
        </div>
        <div className="absolute inset-0 bg-background/50" aria-hidden />
        <div className="relative flex min-h-screen items-center justify-center px-6 py-10">
          <BrandRecapModal open inline onClose={() => {}} />
        </div>
      </div>
    );
  }
  return <>{children}</>;
};

export default CommunityAccessGate;
